import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled]   = useState(false);
  const [mounted,  setMounted]    = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const t = setTimeout(() => setMounted(true), 80);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 16);
    window.addEventListener("scroll", fn, { passive: true });
    return () => window.removeEventListener("scroll", fn);
  }, []);

  return (
    <header style={{
      position: "fixed", top: 0, left: 0, right: 0, zIndex: 200,
      opacity: mounted ? 1 : 0,
      transform: mounted ? "translateY(0)" : "translateY(-10px)",
      transition: "opacity 0.5s ease, transform 0.5s ease",
    }}>
      <div style={{
        maxWidth: 1200, margin: "0 auto",
        padding: scrolled ? "10px 24px" : "20px 24px",
        transition: "padding 0.35s ease",
      }}>
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "space-between",
          height: 54, padding: "0 22px",
          background: scrolled
            ? "rgba(6,8,15,0.95)"
            : "rgba(6,8,15,0.4)",
          backdropFilter: "blur(24px)",
          WebkitBackdropFilter: "blur(24px)",
          border: scrolled
            ? "1px solid rgba(255,255,255,0.1)"
            : "1px solid rgba(255,255,255,0.06)",
          borderRadius: 14,
          boxShadow: scrolled ? "0 8px 40px rgba(0,0,0,0.55)" : "none",
          transition: "all 0.35s ease",
        }}>

          {/* Logo */}
          <Link to="/" style={{ display: "flex", alignItems: "center", textDecoration: "none", flexShrink: 0 }}>
            <img
              src="/images/alphastack-logo-pVgok4VY (1).png"
              alt="AlphaStack"
              style={{ height: 30, objectFit: "contain" }}
            />
          </Link>

          {/* Nav links */}
          {pathname !== "/admin" && (
            <nav style={{ display: "flex", alignItems: "center", gap: 2 }} className="hide-mobile">
              {[["#features", "Features"], ["#stats", "Why AlphaStack"]].map(([href, label]) => (
                <NavItem key={href} href={href} label={label} />
              ))}
            </nav>
          )}

          {/* Right */}
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            {pathname === "/admin" ? (
              <Link to="/" style={{
                fontSize: "0.82rem", color: "rgba(240,238,246,0.5)",
                textDecoration: "none", fontFamily: "Space Grotesk, sans-serif",
              }}>
                ← Back to site
              </Link>
            ) : (
              <>
                <Link to="/admin" style={{
                  fontSize: "0.75rem", color: "rgba(240,238,246,0.25)",
                  textDecoration: "none", fontFamily: "Space Grotesk, sans-serif",
                  padding: "4px 8px",
                }}>
                  Admin
                </Link>
                <NavCTA href="#hero-form" />
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}

function NavItem({ href, label }) {
  const [hovered, setHovered] = useState(false);
  return (
    <a href={href}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        color: hovered ? "rgba(240,238,246,0.88)" : "rgba(240,238,246,0.44)",
        fontSize: "0.86rem", fontWeight: 500,
        fontFamily: "Space Grotesk, sans-serif",
        textDecoration: "none", padding: "6px 14px", borderRadius: 8,
        background: hovered ? "rgba(255,255,255,0.055)" : "transparent",
        transition: "all 0.18s ease",
      }}>
      {label}
    </a>
  );
}

function NavCTA({ href }) {
  const [hovered, setHovered] = useState(false);
  return (
    <a href={href}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        fontSize: "0.85rem", fontWeight: 700,
        fontFamily: "Space Grotesk, sans-serif",
        color: "#050508",
        background: hovered
          ? "linear-gradient(135deg, #A7F3D0, #10B77F)"
          : "linear-gradient(135deg, #6EE7B7, #10B77F, #059669)",
        padding: "8px 20px", borderRadius: 10,
        textDecoration: "none", display: "inline-block",
        transform: hovered ? "translateY(-1px)" : "translateY(0)",
        boxShadow: hovered
          ? "0 8px 28px rgba(16,183,127,0.5)"
          : "0 4px 16px rgba(16,183,127,0.3)",
        transition: "all 0.2s ease", whiteSpace: "nowrap",
      }}>
      Get Early Access
    </a>
  );
}
